import Select from '@components/forms/Select'
import { useCallback } from 'react'
import { localStorageKey, useLocalStorage } from 'hooks/useLocalStorageState'
import useThemeWrapper from 'hooks/useThemeWrapper'
import { SETTINGS_BUTTON_TITLE_CLASSES } from '@components/modals/SettingsModal'
import { useTranslation } from 'next-i18next'
import { clsx } from 'clsx'

const NOTIFICATION_POSITIONS = [
  'Bottom-Left',
  'Bottom-Right',
  'Top-Left',
  'Top-Right',
] as const
export type NotificationPosition = (typeof NOTIFICATION_POSITIONS)[number]
export const NOTIFICATION_POSITION_KEY = localStorageKey<NotificationPosition>(
  'notificationPosition-0.2',
  'Bottom-Left',
)

const THEME_MAP = {
  Light: {
    name: 'Light',
    translation: 'light',
  },
  Dark: {
    name: 'Dark',
    translation: 'dark',
  },
} as const
type ThemeName = keyof typeof THEME_MAP
const THEMES = Object.values(
  THEME_MAP,
) as readonly (typeof THEME_MAP)[ThemeName][]
const DEFAULT_THEME_NAME = THEME_MAP.Light.name

const DisplaySettings = () => {
  // const { i18n } = useTranslation('settings')
  const { t } = useTranslation('settings')
  const { theme, setTheme } = useThemeWrapper()
  // const router = useRouter()
  // const { pathname, asPath, query } = router
  //
  // const [, setSavedLanguage] = useLocalStorage(LANGUAGE_KEY)

  const [notificationPosition, setNotificationPosition] = useLocalStorage(
    NOTIFICATION_POSITION_KEY,
  )

  const updateNotificationPosition = useCallback(
    (position: NotificationPosition) => setNotificationPosition(position),
    [setNotificationPosition],
  )

  // const handleLangChange = useCallback(
  //   async (l: string) => {
  //     setSavedLanguage(l)
  //     await i18n.changeLanguage(l)
  //     router.replace({ pathname, query }, asPath, { locale: l, shallow: true })
  //   },
  //   [router, pathname, query, asPath, setSavedLanguage, i18n],
  // )

  return (
    <div className="border-b border-th-bkg-3">
      <div className="flex flex-col border-t border-th-bkg-3 py-4 md:flex-row md:items-center md:justify-between md:px-4">
        <p className={clsx('mb-2 md:mb-0', SETTINGS_BUTTON_TITLE_CLASSES)}>
          {t('theme')}
        </p>
        <div className="w-full min-w-[140px] md:w-auto">
          <Select
            value={
              theme in THEME_MAP ? (theme as ThemeName) : DEFAULT_THEME_NAME
            }
            renderValue={(theme) => t(THEME_MAP[theme].translation)}
            onChange={(value) => {
              const themeName =
                THEMES.find(({ name }) => name === value)?.name ??
                DEFAULT_THEME_NAME
              setTheme(themeName)
            }}
            className="w-full"
          >
            {THEMES.map(({ name, translation }) => (
              <Select.Option key={name} value={name}>
                {t(translation)}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
      {/* <div className="flex flex-col border-t border-th-bkg-3 py-4 md:flex-row md:items-center md:justify-between md:px-4">
        <p className={`mb-2 md:mb-0 ${SETTINGS_BUTTON_TITLE_CLASSES}`}>
          {t('language')}
        </p>
        <div className="w-full min-w-[280px] md:w-auto md:pl-4">
          <ButtonGroup
            activeValue={savedLanguage}
            onChange={handleLangChange}
            values={LANGS.map((val) => val.locale)}
            names={LANGS.map((val) => t(val.name))}
          />
        </div>
      </div> */}
      <div className="hidden border-t border-th-bkg-3 py-4 md:flex md:flex-row md:items-center md:justify-between md:px-4">
        <p className={clsx('mb-2 md:mb-0', SETTINGS_BUTTON_TITLE_CLASSES)}>
          {t('notification-position')}
        </p>
        <div className="w-full min-w-[140px] md:w-auto">
          <Select
            value={notificationPosition}
            renderValue={(value) => t(value)}
            onChange={updateNotificationPosition}
            className="w-full"
          >
            {NOTIFICATION_POSITIONS.map((val) => (
              <Select.Option key={val} value={val}>
                {t(val)}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
    </div>
  )
}

export default DisplaySettings
